import { ApplicationRootState } from 'redux-core/types';
import { createSelector } from 'reselect';
import { initialState } from './reducer';

const selectAdminTimezones = (state: ApplicationRootState) =>
    state.admin.timezones || initialState;

export const selectTimezonesList = createSelector(
    selectAdminTimezones,
    (state) => state.list
);

export const selectTimezonesOptions = createSelector(
    selectTimezonesList,
    (timezones) => {
        return (
            timezones.data?.map((timezone) => ({
                label: timezone.name,
                value: timezone.id,
            })) ?? []
        );
    }
);
